import { Input } from "@/components/ui/input"

import { CompanyDetailsFields } from "./company-details-fields"
import type { AdditionalCompany, CompanyDetails, ShareChoice } from "./types"

type AdditionalCompanyCardProps = {
  index: number
  clientId: string
  value: AdditionalCompany
  primary: Pick<CompanyDetails, "domain" | "slug" | "logoFile">
  errors?: Record<string, string>
  onChange: (next: AdditionalCompany) => void
}

export function AdditionalCompanyCard({
  index,
  clientId,
  value,
  primary,
  errors,
  onChange,
}: AdditionalCompanyCardProps) {
  function handleShareModeChange(field: "domain" | "slug" | "logo", mode: ShareChoice) {
    if (field === "domain") onChange({ ...value, domainMode: mode })
    if (field === "slug") onChange({ ...value, slugMode: mode })
    if (field === "logo") onChange({ ...value, logoMode: mode })
  }

  return (
    <div className="rounded-lg border bg-muted/10 p-4 space-y-4">
      <div>
        <h3 className="text-sm font-semibold">Company {index + 2}</h3>
        <p className="text-xs text-muted-foreground mt-1">
          This company stays under the same Client ID.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <div className="text-sm font-medium">Client ID</div>
          <Input value={clientId || "—"} disabled />
        </div>

        <CompanyDetailsFields
          value={value}
          onChange={(next) => onChange({ ...value, ...next })}
          errors={errors}
          shareModes={{
            domain: value.domainMode,
            slug: value.slugMode,
            logo: value.logoMode,
          }}
          onShareModeChange={handleShareModeChange}
          primary={primary}
          fieldIdPrefix={`additional-${index}-`}
        />
      </div>
    </div>
  )
}
